import { useQuery } from 'react-query';

import { getCouponPolicyList } from '../graphqls/coupon-policy-list.2';
import {
  CouponCodeType,
  CouponRegistrationType,
  CouponTargetType,
  UserAccountCouponPolicyIssueStatus,
} from '../graphqls/coupon-policy-list_types.2';

export interface CouponPolicyListQueryProps {
  shop_id: string;
  product_id: string;
  include_zonly: boolean;
  options?: {
    enabled?: boolean;
  };
}

export const useCouponPolicyListQuery = ({
  shop_id,
  product_id,
  include_zonly,
  options,
}: CouponPolicyListQueryProps) => {
  const product_id_list: string[] = [product_id];

  return useQuery({
    ...options,
    queryKey: ['couponPolicyList'],
    queryFn: () =>
      getCouponPolicyList(
        {
          include_zonly,
          coupon_registration_type_list: [
            CouponRegistrationType.GENERAL,
            CouponRegistrationType.NEW,
            CouponRegistrationType.BOOKMARK,
          ],
          shop_id_list: [shop_id],
          ...(product_id_list.length > 0 && { product_id_list }),
          coupon_code_type_list: [CouponCodeType.NONE],
          coupon_target_type_list:
            product_id_list.length > 0
              ? [
                  CouponTargetType.SHOP,
                  CouponTargetType.SHOP_WITH_ZONLY,
                  CouponTargetType.SHOP_GROUP,
                  CouponTargetType.SHOP_GROUP_WITH_ZONLY,
                  CouponTargetType.SHOP_GROUP_JUST_ZONLY,
                  CouponTargetType.ORDER_ITEM_GROUP,
                  CouponTargetType.ORDER_ITEM,
                  CouponTargetType.ORDER,
                ]
              : [
                  CouponTargetType.SHOP,
                  CouponTargetType.SHOP_WITH_ZONLY,
                  CouponTargetType.SHOP_GROUP,
                  CouponTargetType.SHOP_GROUP_WITH_ZONLY,
                  CouponTargetType.SHOP_GROUP_JUST_ZONLY,
                ],
          issue_status: UserAccountCouponPolicyIssueStatus.ISSUING,
        },
        {
          show_alert: false,
        },
      ),
  });
};
